/**
 * Single source of truth for local SEO (NAP + geo).
 * Google Maps listing is at /g/11tj667fql (5★). Schema must match that pin —
 * not Barrie city centre (~7 km north).
 */

export const BAKERY_LOCAL = {
  name: "Nanny B's Bakery",
  siteUrl: 'https://nannybbakery.ca',
  schemaId: 'https://nannybbakery.ca/#bakery',
  telephone: '(705) 503-4966',
  email: 'nannybbakedgoods@outlook.com',
  streetAddress: '62 Commerce Park Drive, Unit L',
  addressLocality: 'Barrie',
  addressRegion: 'ON',
  postalCode: 'L4N 8W8',
  addressCountry: 'CA',
  addressFull: '62 Commerce Park Drive, Unit L, Barrie, ON L4N 8W8',
  /**
   * Google Business pin for Nanny B's Bakery (/g/11tj667fql).
   * Do not embed the civic address alone — that pins the plaza building, not the shop.
   */
  latitude: 44.3251647,
  longitude: -79.6841505,
  googleMapsUrl:
    "https://www.google.com/maps/place/Nanny+B's+Bakery/@44.3251647,-79.6841505,16z/data=!4m6!3m5!1s0x882abd8d96b7196d:0x4936e6de9571abae!8m2!3d44.3251647!4d-79.6841505!16s%2Fg%2F11tj667fql",
  /** Same search URL as Testimonials — opens the Maps profile to leave a review. */
  googleReviewUrl:
    "https://www.google.com/maps/search/?api=1&query=Nanny+B%27s+Bakery+62+Commerce+Park+Drive+Barrie+Ontario",
  /** Embed the bakery Place, not "62 Commerce Park Drive Unit L". */
  mapsEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2852!2d-79.6841505!3d44.3251647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882abd8d96b7196d%3A0x4936e6de9571abae!2sNanny%20B%27s%20Bakery!5e0!3m2!1sen!2sca',
  facebookUrl: 'https://www.facebook.com/profile.php?id=100086623726840',
  instagramUrl: 'https://www.instagram.com/nannybbakery/',
  logoPath: '/assets/images/branding/logo2.webp',
  storefrontPath: '/assets/images/exterior/storefront-exterior.webp',
  areaServed: ['Barrie', 'Innisfil', 'Oro-Medonte', 'Springwater'],
  hoursShort: 'Tue–Fri 11am–4:30pm, Sat 10am–3pm. Closed Sun–Mon.',
} as const;

export { BAKERY_LOCAL_FAQS, buildFaqSchemaData } from './bakeryFaqs';

/** JSON-LD fields for schema.org/Bakery (merged into StructuredData). */
export function buildBakerySchemaData(imageUrl: string, logoUrl: string) {
  return {
    '@id': BAKERY_LOCAL.schemaId,
    name: BAKERY_LOCAL.name,
    image: imageUrl,
    logo: { '@type': 'ImageObject', url: logoUrl },
    url: BAKERY_LOCAL.siteUrl,
    telephone: BAKERY_LOCAL.telephone,
    email: BAKERY_LOCAL.email,
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      streetAddress: BAKERY_LOCAL.streetAddress,
      addressLocality: BAKERY_LOCAL.addressLocality,
      addressRegion: BAKERY_LOCAL.addressRegion,
      postalCode: BAKERY_LOCAL.postalCode,
      addressCountry: BAKERY_LOCAL.addressCountry,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: BAKERY_LOCAL.latitude,
      longitude: BAKERY_LOCAL.longitude,
    },
    hasMap: BAKERY_LOCAL.googleMapsUrl,
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '11:00',
        closes: '16:30',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '10:00',
        closes: '15:00',
      },
    ],
    sameAs: [
      BAKERY_LOCAL.facebookUrl,
      BAKERY_LOCAL.instagramUrl,
      BAKERY_LOCAL.googleMapsUrl,
    ],
    areaServed: [...BAKERY_LOCAL.areaServed],
    servesCuisine: 'Bakery',
    hasMenu: `${BAKERY_LOCAL.siteUrl}/menu`,
    currenciesAccepted: 'CAD',
  };
}
